import moment, { unitOfTime, Moment } from 'moment';
import config from '~/config';
import { serverDateTimeFormat, clientDateFormat, clientTimeFormat } from '~/constants/dateTime';
import { hyphen } from '~/constants/string';

export const getCurrentTime = () => moment().format(config.timeFormat);

export const getDiffBetweenDates = (start: Moment, end?: Moment, units: unitOfTime.Diff = 'seconds') =>
  moment(end).diff(start, units);

export const getDateInMoment = (date: string, format: string = serverDateTimeFormat) => moment(date, format);

export const dateInFormat = (date?: null | string, format: string = clientDateFormat) => {
  if (!date) return hyphen;

  return moment(date).format(format);
};

export const timeInFormat = (date?: null | string, format: string = clientTimeFormat) => {
  if (!date) return hyphen;

  return moment(date).format(format);
};
